namespace $ { $mol_style_attach( "shm/theme/theme.css",
 ":root {\n\t--shm_theme_success: var(--mol_theme_current);\n\t--shm_theme_active: #f08c00;\n\t--shm_theme_error: #e03131;\n}\n"
) }